import { render, staticRenderFns } from "./SourceManage.vue?vue&type=template&id=1d9a756d&scoped=true"
import script from "./SourceManage.vue?vue&type=script&lang=ts"
export * from "./SourceManage.vue?vue&type=script&lang=ts"
import style0 from "./SourceManage.vue?vue&type=style&index=0&id=1d9a756d&prod&lang=scss&scoped=true"
import style1 from "./SourceManage.vue?vue&type=style&index=1&id=1d9a756d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a756d",
  null
  
)

export default component.exports